export const BLOG = 'blog';
export const FACEBOOK = 'facebook';
export const GENERAL = 'general';
export const INSTAGRAM = 'instagram';
export const SOCIAL = 'social';
export const TWITTER = 'twitter';
export const YOUTUBE = 'youtube';
